import type { ReactNode } from "react";

import { Image } from "expo-image";
import { StyleSheet, type ViewStyle } from "react-native";

import { GBlurView } from "@/components/GBlurView";

export function DarkBlurCard({
  children,
  imageUrl,
  style,
}: {
  children?: ReactNode;
  imageUrl?: null | string;
  style?: ViewStyle;
}) {
  return (
    <GBlurView style={[{ borderRadius: 24 }, style]}>
      {imageUrl && (
        <Image
          contentFit="cover"
          source={{ uri: imageUrl }}
          style={StyleSheet.absoluteFill}
        />
      )}
      {children}
    </GBlurView>
  );
}
